import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { changeShipmentPosting } from '../../../../../actions/postings';
import PostingsApi from '../../../../../API/shipment/postings-api';
import { PopUp, Row } from '../../../../../components/Basic/Blocks';
import { Button, CheckButton } from '../../../../../components/Basic/Buttons';
import { TextArea } from '../../../../../components/Basic/Inputs';
import { H2, Text } from '../../../../../components/Basic/WrapsStyle';
import { TYPE_BUTTONS } from '../../../../../constans';
import styles from './styles.module.scss';

const ChznWindowPopUp = ({ close = () => { }, product = {}, posting = {} }) => {
  const [arts, setArts] = useState([]);
  const [value, setValue] = useState(product.chzn.value);
  const [not_chzn, setNotChzn] = useState(product.chzn.is_missing);

  const dispatch = useDispatch();

  const testF = (v) => {
    setValue(v);
    const array = v.split('\n').filter((item) => item !== '');
    setArts(array);
  };


  const onChangeProduct = async (id, productId, field, value, action = undefined) => {
    await PostingsApi.changeProductInPosting({ data: { postingNumber: id, productId, field, value, action } }).then((r) => {
      dispatch(changeShipmentPosting(r.posting));
    });
  };


  return (
    <PopUp close={close} clickOutside={false} className={styles.pop_up}>
      <H2 style={{ marginBottom: '20px' }}>{`Введите маркировку товара(ов)`}</H2>
      <TextArea
        width={'600px'}
        value={value}
        placeholder={'маркировка'}
        minRow={10}
        maxRow={15}
        onChange={(v) => testF(v)}
        disabled={not_chzn}
      />

      <Row style={{ width: '190px', marginBottom: '10px', marginTop: '10px' }}>
        <CheckButton
          checked={not_chzn}
          onSelect={(v) => {
            onChangeProduct(posting.posting_number, product._id, 'not_chzn', v).then(() => close());
            setNotChzn(v);
          }}
        />

        <Text style={{ marginLeft: '10px', marginTop: '1px' }} fontSize={'18px'}>
          Нет маркировки
        </Text>
      </Row>

      <Row style={{ marginTop: '30px' }}>
        <Button
          type={TYPE_BUTTONS.BLUE}
          style={{
            marginRight: '15px',
          }}
          onClick={() => {
            onChangeProduct(posting.posting_number, product._id, 'number_chzn', value).then(() => close());
          }}
        >
          Сохранить
        </Button>
        <Button type={TYPE_BUTTONS.GREY} onClick={close}>
          Отмена
        </Button>
      </Row>
    </PopUp>
  );
};

export default ChznWindowPopUp;
